<div *ngFor="let data of avisosService.Banner" class="yc-aviso yc-aviso-{{data.Color}}">

  <i class="{{data.Icono}} icon"></i>

  <div>
    <p class="body-medium">{{data.Aviso}}</p>
    <a (click)="ir(data.Ruta)" class="bodylink-medium">{{data.Button}}</a>
  </div>

  <i *ngIf="data.Ocultar" (click)="avisosService.BorrarAviso(data.CodAviso)" class="ri-close-fill close"></i>

</div>